import { deleteToken } from '../../reduxActions/tokenSlice';
import {
  useAppDispatch,
  useAppSelector,
} from '../../storeHook';
import { encrypted } from '../utility';

interface AuthUser {
  token: string;
}

export const getDecryptedToken = (): AuthUser | null => {
  const authUser = localStorage.getItem('authToken');
  if (!authUser) return null;

  try {
    const decrypted = encrypted.decrypt(authUser);

    try {
      const parsed = JSON.parse(decrypted);
      if (parsed && typeof parsed === 'object' && 'token' in parsed) {
        return parsed as AuthUser;
      }
    } catch (parseError) {
      if (typeof decrypted === 'string' && decrypted.trim().length > 0) {
        if (!decrypted.trim().startsWith('{') && !decrypted.trim().startsWith('[')) {
          return { token: decrypted.trim() };
        }
      }
      throw parseError;
    }

    return null;
  } catch (err) {
    console.error('Failed to decrypt or parse auth token:', err);
    return null;
  }
};

export const getToken = () => {
  const stateToken = useAppSelector(
    (state) => state.token
  ).token;
  return stateToken
    ? stateToken
    : getDecryptedToken();
};

export const useLogOut = () => {
  const dispatch = useAppDispatch();
  const doLogOut = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('isPolicy');
    dispatch(deleteToken());
    window.location.reload();
  };

  return doLogOut;
};
